if (!customElements.get('fmv-retail-total')) {
  customElements.define('fmv-retail-total', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.update = () => {
        const form = this.root.querySelector('form.main-product-form');
        const price = this.root.querySelector('[data-fmv-unit-price]');
        const quantity = form?.elements.namedItem('quantity');
        const id = form?.elements.namedItem('id');
        const count = quantity ? Number(quantity.value) : 1;
        const trade = this.root.querySelector('fmv-trade-price');
        const tradeReady = !trade || (!trade.hidden && trade.dataset.variant === id?.value && trade.dataset.tradeCents !== undefined);
        const valid = tradeReady && price && id && price.dataset.fmvVariant === id.value && Number.isInteger(count) && count > 0 && (!quantity || quantity.checkValidity());
        this.hidden = !valid;
        const netLine = this.querySelector('[data-net-total-line]');
        if (netLine) netLine.hidden = true;
        if (valid) {
          const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency', currency: this.dataset.currency || 'GBP'
          });
          const totalCents = Number(trade ? trade.dataset.tradeCents : price.dataset.fmvUnitPrice) * count;
          this.querySelector('[data-total]').textContent = formatter.format(totalCents / 100);
          if (netLine && trade && this.dataset.currency === 'GBP' && this.dataset.taxesIncluded === 'true') {
            const netCents = trade.dataset.taxable === 'true' ? Math.round(totalCents / 1.2) : totalCents;
            this.querySelector('[data-net-total]').textContent = formatter.format(netCents / 100);
            netLine.hidden = false;
          }
        }
      };
      this.onChange = event => {
        if (event.target.closest('variant-selects')) this.hidden = true;
        else this.update();
      };
      this.root.addEventListener('input', this.onChange);
      this.root.addEventListener('change', this.onChange);
      this.root.addEventListener('fmv:trade-price', this.update);
      this.observer = new MutationObserver(this.update);
      const priceContainer = this.root.querySelector('[id^="price-"]');
      if (priceContainer) this.observer.observe(priceContainer, {childList:true,subtree:true,attributes:true});
      this.update();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('input', this.onChange);
      this.root?.removeEventListener('change', this.onChange);
      this.root?.removeEventListener('fmv:trade-price', this.update);
      this.observer?.disconnect();
    }
  });
}
